import { BreakpointsContext } from '@src/providers/Breakpoints';
import { classnames } from '@src/utils/classnames';
import React, { FC, useContext, useMemo } from 'react';
import { ShowMore } from '../ShowMore';
import styled from './Accordion.scss';
import { IAccordionProps } from './models';
import { AccordionItemUnit } from './_ItemUnit/AccordionItemUnit';

export const Accordion: FC<IAccordionProps> = ({
  btnView = 'textLight',
  items,
  maxItems,
  className,
  style,
  size = 'md',
  nestedInteractive = false,
  disableAnimation,
}) => {
  const { isMobile } = useContext(BreakpointsContext);
  const classes = classnames(styled.root, className);

  const content = useMemo(() => {
    return items.map((item) => (
      <AccordionItemUnit
        key={item.id}
        {...item}
        size={size}
        disableAnimation={disableAnimation}
        nestedInteractive={nestedInteractive}
      />
    ));
  }, [disableAnimation, items, size, nestedInteractive]);

  return (
    <div className={classes} style={style}>
      <ShowMore
        htmlContent={content}
        maxItems={maxItems}
        btnView={btnView}
        disableAnimation={disableAnimation}
        btnSize={isMobile ? 'sm' : 'md'}
        useSmallBtnPadding={false}
      />
    </div>
  );
};
